
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  MigrateCompanyManagersResponse,
  MigrateOrganizationManagersResponse,
} from '../models';
import {
    MigrateCompanyManagersResponseFromJSON,
    MigrateCompanyManagersResponseToJSON,
    MigrateOrganizationManagersResponseFromJSON,
    MigrateOrganizationManagersResponseToJSON,
} from '../models';

export interface MigrateCompanyManagersRequest {
    file: Blob;
}

export interface MigrateOrganizationManagersRequest {
    file: Blob;
}

/**
 * 
 */
export class ManagerMigrationApi extends runtime.BaseAPI {

    /**
     * Upload bulk company manager migration file
          */
    async migrateCompanyManagersRaw(requestParameters: MigrateCompanyManagersRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<MigrateCompanyManagersResponse>> {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling migrateCompanyManagers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        const response = await this.request<MigrateCompanyManagersResponse>({
            path: `/client-settings/api/admin/managers/migrations/company-manager-migration`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        if (response._data) { response._data=MigrateCompanyManagersResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Upload bulk company manager migration file
          */
    async migrateCompanyManagers(requestParameters: MigrateCompanyManagersRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<MigrateCompanyManagersResponse> {
        const response = await this.migrateCompanyManagersRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Upload bulk organization manager migration file
          */
    async migrateOrganizationManagersRaw(requestParameters: MigrateOrganizationManagersRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<MigrateOrganizationManagersResponse>> {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling migrateOrganizationManagers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        const response = await this.request<MigrateOrganizationManagersResponse>({
            path: `/client-settings/api/admin/managers/migrations/organization-manager-migration`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        if (response._data) { response._data=MigrateOrganizationManagersResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Upload bulk organization manager migration file
          */
    async migrateOrganizationManagers(requestParameters: MigrateOrganizationManagersRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<MigrateOrganizationManagersResponse> {
        const response = await this.migrateOrganizationManagersRaw(requestParameters, initOverrides);
        return response._data;
    }

}
